import { computed, ref, Ref } from "vue";
import { UserAuth } from "../../domain/login";

const emptyUserAuth: UserAuth = {
  username: "",
  token: "",
  role: "",
};

const memoryUserAuth: Ref<UserAuth> = ref({ ...emptyUserAuth });

export function userAuthStore() {
  async function updateUserAuthSession(newUserAuth: UserAuth) {
    memoryUserAuth.value = newUserAuth;
  }

  function reset(): void {
    memoryUserAuth.value = { ...emptyUserAuth };
  }

  const isEmpty = computed(() => {
    return memoryUserAuth.value.username === emptyUserAuth.username;
  });

  const isAuth = computed(() => memoryUserAuth.value.token !== "");

  return {
    updateUserAuthSession,
    isEmpty,
    memoryUserAuth: memoryUserAuth.value,
    reset,
    isAuth,
  };
}
